module.exports = __webpack_public_path__ + "img/back_button.fe40b7a4.png";